export default {"src":"/_next/static/media/europe.54fc98f7.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};